import { Skeleton } from "antd";

export default function LoadingHeader() {
  return (
    <Skeleton
      active
      size="default"
      paragraph={{
        rows: 1,
      }}
    />
  );
}